export const localStorageKey = "activeMacawUITheme";
export const defaultTheme = "defaultLight";
